export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor" />
      <rect x="13" y="2" width="9" height="9" rx="2" fill="currentColor" />
      <rect x="2" y="13" width="9" height="9" rx="2" fill="currentColor" />
      <rect x="13" y="13" width="9" height="9" rx="2" fill="currentColor" />
    </svg>
  );
}
